"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInAppBrowser = exports.loadScript = void 0;
function loadScript(url) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement("script");
            scriptElement.setAttribute("type", "text/javascript");
            scriptElement.src = url;
            scriptElement.onload = function () {
                var _a;
                resolve(true);
                (_a = scriptElement.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(scriptElement);
            };
            scriptElement.onerror = function () {
                var _a;
                reject("Fehler beim Laden des Scriptes");
                (_a = scriptElement.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(scriptElement);
            };
            document.body.appendChild(scriptElement);
        });
    });
}
exports.loadScript = loadScript;
const inAppBrowserIndicators = [
    "fb_iab",
    "fban",
    "fbav",
    "gsa",
    "instagram",
    "linkedinapp",
    "messenger",
    "pinterest",
    "snapchat",
    "bytelocale",
    "bytedancewebview",
    "twitter",
    "whatsapp",
    "youtube",
];
function isInAppBrowser() {
    const lowerCasedUA = (navigator.userAgent || "").toLowerCase();
    return inAppBrowserIndicators.some((indicator) => lowerCasedUA.includes(indicator));
}
exports.isInAppBrowser = isInAppBrowser;
